import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getInvoices } from 'modules/accommodations/features/reservations/api';

export const useQueryInvoices = ({ id }: { id: string | null }) => {
  return useQuery([QUERY_KEYS.RENTALS_ACCOMMODATION_INVOICES, id], () => getInvoices({ id }), {
    enabled: !!id,
  });
};
